// import { useState } from "react";
// import {
//   fetchCurrencies,
//   createCurrency,
//   updateCurrency,
//   deleteCurrency as deleteCurrencyApi,
//   getCurrencies,
// } from "../../../api/currency.api";

// export const useCurrency = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const loadCurrencies = async () => {
//     setLoading(true);
//     const res = await getCurrencies();
//     setData(res.data || []);
//     setLoading(false);
//   };

//   const addCurrency = (payload) => createCurrency(payload);
//   const editCurrency = (id, payload) =>
//     updateCurrency(id, payload);

//   const deleteCurrency = async (id, payload) => {
//     const res = await deleteCurrencyApi(id, payload);
//     return res.data;
//   };

//   return {
//     data,
//     loading,
//     loadCurrencies,
//     addCurrency,
//     editCurrency,
//     deleteCurrency,
//   };
// };

import { useState } from "react";
import {
  createCurrency,
  updateCurrency,
  deleteCurrency as deleteCurrencyApi,
  getCurrencies,
} from "../../../api/currency.api";

export const useCurrency = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    totalCurrencies: 0,
    totalPages: 1,
  });

  const loadCurrencies = async (options = {}) => {
    setLoading(true);
    try {
      const res = await getCurrencies({
        page: options.page || 1,
        limit: options.limit || 10,
        search: options.search || "",
      });

      const payload = res?.data || {};
      const list =
        payload.currencies ||
        payload.data?.currencies ||
        payload.data ||
        (Array.isArray(payload) ? payload : []);

      setData(list);

      setPaginationInfo({
        totalCurrencies:
          payload.pagination?.totalCurrencies ||
          payload.total ||
          list.length,
        totalPages: payload.pagination?.totalPages || payload.totalPages || 1,
      });
    } catch (error) {
      console.error("Error fetching currencies:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const addCurrency = (payload) => createCurrency(payload);
  const editCurrency = (id, payload) => updateCurrency(id, payload);

  const deleteCurrency = async (id, payload) => {
    const res = await deleteCurrencyApi(id, payload);
    return res.data;
  };

  return {
    data,
    loading,
    paginationInfo,
    loadCurrencies,
    addCurrency,
    editCurrency,
    deleteCurrency,
  };
};